import React from 'react';

import { Navigate, NavigateProps } from 'react-router-dom';

import { RoutePath } from './types';

interface AppNavigateProps extends Omit<NavigateProps, 'to'> {
  to: RoutePath;
}

export const AppNavigate: React.FC<AppNavigateProps> = (props) => {
  return <Navigate {...props} />;
};
